var WishList = {
	init:function(){
		this.addToWishlist();
		this.removeFromWishlist();

		$(".must--logged .btn-close").on("click touchend", function(e){
			e.stopPropagation();
			e.preventDefault();
			if(e.type=='touchend'){
				$(this).off("click");
			}

			$(".must--logged").removeClass("visible");
		});

		$(".must--logged .shadow").on("click touchend", function(e){
			e.stopPropagation();
			e.preventDefault();
			if(e.type=='touchend'){
				$(this).off("click");
			}

			$(".must--logged").removeClass("visible");
		});

	},
	removeFromWishlist: function(){
		$('.remove--wishlist').on('click', function(ev){
			WishList.fc_remove($(this), ev, "wishlist");
		});
	},
	fc_remove: function(_this, ev, type){
		ev.preventDefault();
		var productId = _this.data('product');
		data = 'action=akrolab_remove_from_wishlist&idProduct=' + productId;
		Debug.log("Test ajout wishlist ajax : " + productId);
		$.ajax({
			url: ajaxurl,
			type:'POST',
			data: data,
			beforeSend:function() {
				_this.addClass("loading");
			},
			success: function (results) {

				_this.removeClass("loading");
				results = JSON.parse(results);
				Debug.log("Ajout wishlist : " + results.success);
				if(results.success){

					if(type == 'wishlist'){
						$('.total--wishlist').html(results.result.totalQuantity);
						_this.parent().remove();
						setTimeout(function(){
							if( $(".tease-wishlist").length === 0){
								window.location.href = results.result.redirect;
							}
						}, 40);
					}else{
						_this.removeClass("active");
					}


				}else{
					$('.must--logged').addClass("visible");
				}
			}
		});
	},
	addToWishlist: function(){
		$('.btn--like').on('click', function(ev){
			ev.preventDefault();

			if(!$(this).hasClass("active")) {

				var productId = $(this).data('product');

				data = 'action=akrolab_add_to_wishlist&idProduct=' + productId;
				var heart = $(this);

				Debug.log("TEST AJOUT WISHLIST ");

				$.ajax({
					url: ajaxurl,
					type: 'POST',
					data: data,
					beforeSend:function() {
						heart.addClass("loading");
					},
					success: function (results) {
						heart.removeClass("loading");
						results = JSON.parse(results);

						Debug.log("AJOUT WISHLIST DONE : result = " + results.success);

						if (results.success) {
							$('.total--wishlist').html(results.result.totalQuantity);
							heart.addClass('active');
						} else {
							$('.must--logged').addClass("visible");
						}
					}
				});
			}else{
                WishList.fc_remove($(this), ev, 'picto');
			}
		});
	}
}

$(window).load(function(){
	WishList.init();
})

